import { ChainId } from '../../constants'

import { Arbitrum } from './Arbitrum'
import { Avalanche } from './Avalanche'
import { Base } from './Base'
import { Binance } from './Binance'
import { Brise } from './Brise'
import { Cronos } from './Cronos'
import { Ether } from './Ether'
import { Fantom } from './Fantom'
import { Matic } from './Matic'
import { APE } from './Ape'

// Native exports
export { Binance } from './Binance'
export { Ether } from './Ether'
export { Arbitrum } from './Arbitrum'
export { Fantom } from './Fantom'
export { Matic } from './Matic'
export { Avalanche } from './Avalanche'
export { Cronos } from './Cronos'
export { Brise } from './Brise'
export { Base } from './Base'
export { APE } from './Ape'

export const NATIVE_CURRENCIES = {
  [ChainId.ETHEREUM]: Ether.onChain(ChainId.ETHEREUM),
  [ChainId.ARBITRUM]: Arbitrum.onChain(ChainId.ARBITRUM),
  [ChainId.GOERLI]: Ether.onChain(ChainId.GOERLI),
  [ChainId.BSC_MAINNET]: Binance.onChain(ChainId.BSC_MAINNET),
  [ChainId.BSC_TESTNET]: Binance.onChain(ChainId.BSC_TESTNET),
  [ChainId.FANTOM]: Fantom.onChain(ChainId.FANTOM),
  [ChainId.POLYGON]: Matic.onChain(ChainId.POLYGON),
  [ChainId.AVALANCHE]: Avalanche.onChain(ChainId.AVALANCHE),
  [ChainId.CRONOS]: Cronos.onChain(ChainId.CRONOS),
  [ChainId.BRISE]: Brise.onChain(ChainId.BRISE),
  [ChainId.BASE]: Base.onChain(ChainId.BASE),
  [ChainId.CURTIS]: APE.onChain(ChainId.CURTIS),
  [ChainId.APECHAIN]: APE.onChain(ChainId.APECHAIN)
}
